import { styled } from "styled-components";

export const SignUpAndIoginLayout = styled.div`
  // border: 2px solid yellow;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;

    @media (min-width: 992px) {
    
  }

  .CoverDiv {
    background: ${({ theme }) => theme.loginCoverDiv};
    @media (max-width: 576px) {
      background: none;
    }
    border-radius: 20px;
    width: 100%;
    @media (min-width: 992px) {
      width: 60%;
    }
    .formStyle {
      width: 80%;
      @media (max-width: 576px) {
        width: 100%;
      }
    }
    .questionText {
      margin-top: 1.5rem;
      span {
        font-weight: bold;
        cursor: pointer;
      }
    }
  }

  span {
    font-weight: bold;
  }
   
  
  strong{
  display: block;
  font-weight: bold;
  }

  .greeting{
  font-weight: 200;
  font-size: 22px;
  }

  .instruction {
     text-align: center;
        font-weight: 200;
    font-size: 18px;
  }
`;

export const ResetPasswordLayout = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  // border: 1px solid indigo;
  gap: 10px;

  strong {
    font-size: 23px;
  }

  .centerTxt {
    font-weight: 200;
    font-size: 18px;
    text-align: center;
  }

  .envelop {
    // border: 1px solid yellow;
    width: 60%;
    padding: 10px;
    @media (max-width: 768px) {
      width: 100%;
    }
  }

  .CoverDiv {
    background: ${({ theme }) => theme.loginCoverDiv};
    @media (max-width: 576px) {
      background: none;
      border: none;
    }
    border: 1px solid ${({ theme }) => theme.loginCoverDiv};
    border-radius: 20px;
    width: 100%;
    .formStyle {
      width: 80%;
      @media (max-width: 576px) {
        width: 100%;
      }
    }
  }
`;

export const CenterForm = styled.div`
  // border: 1px solid green;
  margin: 1.5rem 0;
  display: flex;
  justify-content: center;
  align-items: cemter;
`;
